<form *ngIf="fields && form" [formGroup]="form" (submit)="save()" [ngClass]="{'invalid-submit': invalidSubmit}">
  <div class="Loyalty ui-g-12 ui-md-12 ui-lg-12">

    <div class="ui-g">
      <div class="ui-g-9 ui-md-9 ui-lg-9">
        <h1 class="step-title" *ngIf="!editMode">{{ 'layout.add_title' | translate}}</h1>
        <h1 class="step-title" *ngIf="editMode">{{ 'layout.edit_title' | translate}}</h1>
      </div>
      <div class="ui-g-3 ui-md-3 ui-lg-3 form-button-row">
        <button pButton class="k-generic-btn" type="button" icon="fa fa-arrow-left" iconPos="left" routerLink="/loyalty/layout" label="{{ 'common.back' | translate }}"></button>
        <button pButton class="k-generic-btn" (click)="save()" type="button" icon="fa fa-floppy-o" iconPos="left" label="{{'common.save' | translate}}"></button>
      </div>
    </div>

    <div class="card">

      <div class="ui-g ui-fluid">
        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.description.nullable}">{{ fields.description.keyName }}</span>
          <input type="text" pInputText class="fieldInput" formControlName="description"/>
          <!-- MESSAGGIO DI ERRORE -->
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="fields.description"></app-validation-msg>
        </div>
      </div>

      <div class="ui-g">
        <div class="ui-g-11 ui-md-11 ui-lg-11">
          <h3 class="title">{{ 'layout_detail.title_detail' | translate }}</h3>
        </div>
        <div class="ui-g-12 ui-md-12 ">
          <button pButton (click)="aggiungi()" icon="fa fa-plus-circle" iconPos="right" type="button" class="k-generic-btn" label="{{ 'common.add' | translate }}"></button>
        </div>
      </div>

      <div formArrayName="details">
        <div class="ui-g ui-fluid" *ngFor="let detail of details.controls; let i=index" [formGroupName]="i">

          <p-panel class="ui-g-12">

            <p-header>
              <div class="ui-helper-clearfix pull-left">
                <h3 class="title">{{ 'layout_detail.title_detail' | translate}}</h3>
              </div>
              <div class="ui-helper-clearfix pull-right">
                <button pButton type="button" (click)="deleteDetail(i, detail)" icon="fa fa-times" class="ui-button-danger btnDelete"></button>
              </div>
            </p-header>

            <div class="ui-g-12  ui-fluid">

              <div class="ui-g-12 ui-md-4">
                <span class="label" [ngClass]="{'required': !fieldsLayout.row_description.nullable}">{{ fieldsLayout.row_description.keyName | translate }}</span>
                <input type="text" pInputText class="fieldInput" formControlName="row_description"/>
                <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="detail" [validation]="fieldsLayout.row_description"></app-validation-msg>
              </div>
              <div class="ui-g-12 ui-md-2">
                <span class="label" [ngClass]="{'required': !fieldsLayout.row_position.nullable}">{{ fieldsLayout.row_position.keyName | translate }}</span>
                <input type="text" pInputText class="fieldInput" formControlName="row_position"/>
                <span class="input-error-notification" *ngIf="invalidSubmit && detail.get('row_position').errors?.integerNotNegative">Solo caratteri numerici</span>
                <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit"  [arrayValidators]="[validators.integerNotNegative]" [form]="detail" [validation]="fieldsLayout.row_position"></app-validation-msg>
              </div>
              <div class="ui-g-12 ui-md-2">
                <span class="label" [ngClass]="{'required': !fieldsLayout.row_max_lenght.nullable}">{{ fieldsLayout.row_max_lenght.keyName | translate }}</span>
                <input type="text" pInputText class="fieldInput" formControlName="row_max_lenght"/>
                <span class="input-error-notification" *ngIf="invalidSubmit && detail.get('row_max_lenght').errors?.integerNotNegative">Solo caratteri numerici</span>
                <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [arrayValidators]="[validators.integerNotNegative]" [form]="detail" [validation]="fieldsLayout.row_max_lenght"></app-validation-msg>
              </div>
              <div class="ui-g-12 ui-md-2">
                <span class="label" [ngClass]="{'required': !fieldsLayout.start_offset.nullable}">{{ fieldsLayout.start_offset.keyName | translate }}</span>
                <input type="text" pInputText class="fieldInput" formControlName="start_offset"/>
                <span class="input-error-notification" *ngIf="invalidSubmit && detail.get('start_offset').errors?.integerNotNegative">Solo caratteri numerici</span>
                <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [arrayValidators]="[validators.integerNotNegative]" [form]="detail" [validation]="fieldsLayout.start_offset"></app-validation-msg>
              </div>
              <div class="ui-g-12 ui-md-2">
                <span class="label"  [ngClass]="{'required': !fieldsLayout.flg_print.nullable}">{{ fieldsLayout.flg_print.keyName | translate }}</span>
                <p-inputSwitch formControlName="flg_print"></p-inputSwitch>
              </div>

            </div>

            <p-footer class="clearfix">&nbsp;</p-footer>
          </p-panel>

        </div>
      </div>

    </div>
  </div>
</form>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-layout/form-layout-loyalty/form-layout-loyalty.component.html